/*
 * File: index.js
 * Project: mp-mobile-app
 *
 * Copyright (c) 2020 MacPractice, Inc. All rights reserved.
 *
 * Description: HOC for referrals with a context wrapper for sharing state data
 */
import React, { useEffect } from "react";
import PropTypes from "prop-types";
import Router from "components/Router";
import Routes from "./Routes";
import { SearchResultsProvider } from "./state/SearchResultsProvider";

const Index = ({ appStore }) => {
  useEffect(() => {
    appStore.setTitle("Referrers");
    appStore.setRightNav();
  }, [appStore]);

  return (
    <SearchResultsProvider>
      <Router routes={Routes} />
    </SearchResultsProvider>
  );
};

Index.propTypes = {
  appStore: PropTypes.object
};

export default Index;
